// extracted by mini-css-extract-plugin
export default {"imgList":"style_imgList__U0LRr","imgBox":"style_imgBox__FxU9R","img":"style_img__lkfQ0","removeImgBtn":"style_removeImgBtn__qYaus"};